/**
 * Portfolio dashboard layout presets — 3 curated configurations the
 * user can pick from the analytics grid toolbar without entering the
 * drag-drop edit mode. Created in Sprint V2.B4, extracted to its own
 * module in Sprint V2.B4.1 to keep `PortfolioDashboard.tsx` lean.
 *
 * The widget ids used here MUST stay in sync with `ANALYTICS_WIDGETS`
 * in `PortfolioDashboard.tsx`. If a new widget is added there, add a
 * row to each preset below.
 */

export type PortfolioLayoutPresetId = 'compact' | 'standard' | 'power';

export interface PortfolioLayoutPresetEntry {
  id: string;
  cols: number;
}

export const PORTFOLIO_LAYOUT_PRESETS: Record<
  PortfolioLayoutPresetId,
  PortfolioLayoutPresetEntry[]
> = {
  // Compact : 4 cols for analytics, 8 for charts → up to 3 widgets
  // per row, denser overview.
  compact: [
    { id: 'heatmap', cols: 4 },
    { id: 'risk', cols: 4 },
    { id: 'drawdown', cols: 4 },
    { id: 'holding', cols: 4 },
    { id: 'price-chart', cols: 8 },
    { id: 'spread', cols: 8 },
  ],
  // Standard : the existing default — 6 cols mostly, charts at 12.
  standard: [
    { id: 'heatmap', cols: 6 },
    { id: 'risk', cols: 6 },
    { id: 'price-chart', cols: 12 },
    { id: 'spread', cols: 12 },
    { id: 'drawdown', cols: 6 },
    { id: 'holding', cols: 6 },
  ],
  // Power : full-width charts + analytics, focused on data density.
  power: [
    { id: 'price-chart', cols: 12 },
    { id: 'spread', cols: 12 },
    { id: 'risk', cols: 12 },
    { id: 'heatmap', cols: 12 },
    { id: 'drawdown', cols: 12 },
    { id: 'holding', cols: 12 },
  ],
};
